import { BrowserRouter, Routes, Route } from 'react-router-dom';
import NotFound from './Pages/NotFound';
import MailboxCreatePage from './Pages/Mailbox/MailboxCreatePage';
import MailboxEditPage from './Pages/Mailbox/MailboxEditPage';
import MailboxExportPage from './Pages/Mailbox/MailboxExportPage';
import MailboxEditImportPage from './Pages/Mailbox/MailboxEditImportPage';
import MailboxCreateImportPage from './Pages/Mailbox/MailboxCreateImportPage';


function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/mailbox/create/:id" element={<MailboxCreatePage />} />
        <Route path="/mailbox/change/:id" element={<MailboxEditPage />} />
        <Route path="/mailbox/export/:id" element={<MailboxExportPage />} />
        <Route path="/mailbox/import/update/:id" element={<MailboxEditImportPage />} />
        <Route path="/mailbox/import/create/:id" element={<MailboxCreateImportPage />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
